module.exports = __webpack_public_path__ + "static/img/gya_13.8ca0f58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/line/gya_13.jpg
// module id = vjjh
// module chunks = 0